// src/pages/UrgentAlerts/UrgentAlerts.api.js
const BASE = '/urgent-alerts'; // ajuste para '/api/urgent-alerts' se seu backend usa prefixo

async function handle(res) {
  // Tenta ler JSON; se vier HTML (ex.: 401), cria erro legível
  let data = null;
  try { data = await res.json(); } catch { /* ignore */ }
  if (!res.ok || !data?.ok) {
    const msg = data?.message || `${res.status} ${res.statusText}`;
    throw new Error(msg);
  }
  return data;
}

export async function listRules(params = {}) {
  const qs = new URLSearchParams(params).toString();
  const res = await fetch(`${BASE}?${qs}`, {
    method: 'GET',
    credentials: 'include' // envia cookies da sessão
  });
  return handle(res);
}

export async function createRule(payload) {
  const res = await fetch(BASE, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload)
  });
  return handle(res);
}

export async function updateRule(id, payload) {
  const res = await fetch(`${BASE}/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload)
  });
  return handle(res);
}

export async function deleteRule(id) {
  const res = await fetch(`${BASE}/${id}`, {
    method: 'DELETE',
    credentials: 'include'
  });
  return handle(res);
}

export async function toggleActive(id, active) {
  return updateRule(id, { active });
}
